module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-HeavyItalic.ttf?d3bd7cceee245da70ce5f2942fc10774";